// Les trois volets de mesure que sert cette PWA, et les rôles Keycloak qui y donnent accès.
// Reflète MESURE_SAISIE_ST_ROLES / MESURE_SAISIE_DELAVAGE_ROLES / MESURE_SAISIE_FINITION_ROLES
// de measurement-session.model.ts (sipconfection-frontend) — même politique, pour qu'un compte
// autorisé côté web le soit aussi ici. La vraie barrière reste le @PreAuthorize du backend :
// ceci ne pilote que ce que la tablette PROPOSE, pas ce qu'elle autorise.
export const FLOWS = {
  CONFECTION: {
    cle: 'CONFECTION',
    titre: 'Confection',
    sousTitre: 'Mesure des livraisons sous-traitant, avant délavage',
    roles: ['ST', 'COUPE', 'USER', 'OWNER', 'ADMIN', 'SUPERADMIN'],
  },
  DELAVAGE: {
    cle: 'DELAVAGE',
    titre: 'Délavage — réception',
    sousTitre: 'Mesure à la réception, avant passage en machine',
    roles: ['DELAVAGE', 'AUDIT_DELAVAGE', 'OWNER', 'ADMIN', 'SUPERADMIN'],
  },
  FINITION: {
    cle: 'FINITION',
    titre: 'Finition',
    sousTitre: 'Mesure après délavage, au retour en finition',
    roles: ['FINITION', 'PERSONNEL', 'USER', 'COUPE', 'OWNER', 'ADMIN', 'SUPERADMIN'],
  },
};

/** Les volets accessibles à cet ensemble de rôles, dans un ordre stable pour l'affichage. */
export function flowsDisponibles(roles) {
  return Object.values(FLOWS).filter((f) => f.roles.some((r) => roles.includes(r)));
}
